var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.906,
    height: 105.583,
    viewBox: "0 0 64.906 105.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2256.983 -5599.784)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.906,
    height: 104.583,
    rx: 5.12,
    transform: "translate(2257.483 5600.284)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M2257.483 5615.621h63.906m-63.906 71.278h63.906m-37.842-78.074h11.78"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.9,
    cy: 3.9,
    r: 3.9,
    transform: "translate(2285.535 5691.998)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2305.852 5673.12h-32.831a1 1 0 01-1-1.057l1.886-33.219a1 1 0 011-.944h29.059a1 1 0 011 .944l1.887 33.219a1 1 0 01-1.001 1.057z",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2282.3 5643.729V5630.4a1 1 0 011-1h11.943a1 1 0 011 1v13.329",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.737,
    cy: 0.737,
    r: 0.737,
    transform: "translate(2281.564 5644.035)",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.737,
    cy: 0.737,
    r: 0.737,
    transform: "translate(2295.507 5644.035)",
    stroke: "#6e7e9d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneShop);
export default __webpack_public_path__ + "static/media/phoneShop.9d867e262cfda327fcd75c800b1968b9.svg";
export { ForwardRef as ReactComponent };